import React from "react";
import "./AverageStatsDisplay.css";

function show(value) {
  return value === null || value === undefined ? "—" : value;
}

export default function AverageStatsDisplay({ label, statValue, oppStatValue }) {
  return (
    <div className="nfl-sr-avg">
      <span className="nfl-sr-avg-label nfl-display">{label}</span>
      <span className="nfl-sr-avg-value">{show(statValue)}</span>
      <span className="nfl-sr-avg-opp">Opp {show(oppStatValue)}</span>
    </div>
  );
}
